// extracted by mini-css-extract-plugin
export default {"wrapper":"SocialButtons_wrapper__T35Vy","icon":"SocialButtons_icon__QMGM4"};